import MultiSelectWithTreeForOblast from './MultiSelectWithTreeForOblast';

export default MultiSelectWithTreeForOblast;
